 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		40: 0,
 		51: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"vendors~BulkRoster~MergeApproval~MergeRequest~OneRosterOrgs~ProvisionSchools~Pygmalion","5":"News","6":"MergeApproval~MergeRequest","8":"AssignmentContainer","9":"AssignmentsContainer","10":"BulkRoster","11":"Categories","12":"Collections","13":"Home","14":"LazyAssignedArticleReviewContainer","15":"LazyCanvasAssignmentReviewContainer","16":"LazySearchComponent","17":"LessonSparkContainer","18":"MergeApproval","19":"MergeRequest","20":"OneRosterOrgs","21":"OpenMergeRequests","22":"ProvisionSchools","23":"Pygmalion","24":"ReadContainer","25":"Rules","26":"Search","27":"Search Playground","28":"SignIn","29":"StandaloneAudioTrack","30":"StandaloneExternalEmbed","31":"StandalonePoll","32":"StandaloneVideo","33":"StandardContainer","34":"TeacherBinder","35":"TeacherOnboarding","36":"TextSets","37":"UnitsContainer","38":"UserDash","39":"YourContentContainer","41":"browse","44":"vendors~BulkRoster"}[chunkId]||chunkId) + "." + {"0":"0a36aee57388204344bc","1":"1bb533a691894441892d","2":"046fda82ac884742f50c","3":"588b82a2ea5d8ab9b959","4":"7ad51a94200bdede718d","5":"68d820a2c847417a2732","6":"d1b19ae05dd84a8794ba","7":"e62a1f68563271bbd8d7","8":"54db18202cb063903b72","9":"ffd846bc22a6b72891c5","10":"58fe5b9841aeb461c6aa","11":"7277c24169e02b4e14eb","12":"3cb96e7c7bec11904c5d","13":"4bc98d88e83243d4be17","14":"b834dd2f3fedaf9e61ee","15":"7814cbc8e64d03f5bd23","16":"1b5eee27f5e50afa711d","17":"aa825e68337e38214c0d","18":"56411bb74f506c0ccc97","19":"df210593cf22528cac90","20":"b9e4dc0f15ac9dcd6df9","21":"474431b086b830c0f05d","22":"d873a02c778d5628595c","23":"018cf92ab58d2d378475","24":"45007273eeb9f42889e5","25":"52f950481644d1f23a47","26":"75036d68c08d2dd743c5","27":"a309a66ba0f59f16c224","28":"3cdd44452b133217506e","29":"f7c9b790671756d476bd","30":"4614e815ab2abe824dd9","31":"b404d3375aa61e58025f","32":"c2e6579aee3778b1f6ff","33":"2011ab84cd805abc5f71","34":"479239fa6e07d2c535b0","35":"c7122bf04e0e77527308","36":"0c50d9835a8b68427786","37":"c5d7c263f84fa9a394a6","38":"68e49084faef27527455","39":"21beeeab89508f46e498","41":"6599799e14bfae4e7300","44":"f2ea02c7bbec25df1415","45":"e20cfbe6387ac28e174e","46":"1630a53b271e362f195f","47":"d0829500a05e39b223ce","48":"66e2eb07f1ca3c9f11a6","49":"949b331ad251f8ecfae5","50":"d67655ea851fca84ad84","51":"7f62087f17b1221b621e","52":"2c329f01978876f8a611","53":"b381338026b11f4256b2","54":"68af6754c197134d586d","55":"1246dd1807e9f8eac410","56":"864b52d4590f28e98bd9","57":"d22f299d5c77fbc3e1a3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1918);
